import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import CodeDemo from './CodeDemo'
import CodeElement from './CodeElement'
import CodeFormBrand from './CodeFormBrand'
import { STYLE_FORM_SCHEMA } from './CodeFormStyle'
import CodeFormValue from './CodeFormValue'
import codeIcon from './assets/code.svg'

export default genElementConfig(CONFIG_ELEMENTS.code, {
  label: t('elements.code.label'),
  icon: codeIcon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: CodeElement,
  Demo: [CodeDemo],
  FormValue: CodeFormValue,
  FormBrand: CodeFormBrand,
  EditorActions: EditableProMode,
})
